const wait = ms => new Promise((r, j)=>setTimeout(r, ms))
export default wait;